export default __webpack_public_path__ + "static/webinar-series-3e3502dce7f19d0a65853abd561bd20d.png";